import { useState, useEffect } from "react";
import NotFound from "./components/Util/NotFound";
import Home from "./components/Home/Home";
import Templates from "./components/Templates/Templates";
import Layout from "./Layout";
import Editor from "./components/Editor/Editor";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import JSZip from "jszip";
import News from "./components/News/News";

function App() {
  const [textures, setTextures] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // raised to here to darken the background when the hamburger menu is open
  const [toggleHamburger, setToggleHamburger] = useState(true);
  const [activeLink, setActiveLink] = useState("/");
  
  const EXTERNAL_LINKS = {
    Docs: "https://docs.commandpanels.net",
    GitHub: "https://github.com/rockyhawk64/CommandPanels",
    Discord: "https://discord.gg/WFQMTZxa53",
    Download: "https://modrinth.com/plugin/commandpanels",
    bStats: "https://bstats.org/plugin/bukkit/CommandPanels/5097"
  };

  const loadTextures = async () => {
    const zipFileName = "./assets/Item_Textures.zip";
    const zipFileResponse = await fetch(zipFileName);
  
    if (!zipFileResponse.ok) {
      throw new Error(`Failed to load ZIP file: ${zipFileResponse.statusText}`);
    }
  
    const zipFileBlob = await zipFileResponse.blob();
    const zip = await JSZip.loadAsync(zipFileBlob);
  
    const texturePromises = Object.keys(zip.files).map(async (fileName) => {
      const file = zip.file(fileName);
      const blob = await file.async("blob");
      const url = URL.createObjectURL(blob);
      return { fileName, url };
    });
  
    const loadedTextures = await Promise.all(texturePromises);
    setTextures(loadedTextures);
    setIsLoading(false);
  };  

  useEffect(() => {
    // set the active link to the current page when the page is loaded
    setActiveLink(window.location.pathname.split("/")[1]);

    loadTextures();
  }, []);  

  return (
    <div className="appContainer">
      <div className={!toggleHamburger ? "routerContainer active" : "routerContainer"}>
        <Router>
          <Routes>
            <Route path="/" element={<Layout EXTERNAL_LINKS={EXTERNAL_LINKS} toggleHamburger={toggleHamburger} setToggleHamburger={setToggleHamburger} activeLink={activeLink} setActiveLink={setActiveLink}/>}>
              <Route index element={<Navigate replace to="/home" />} />
              <Route path="/home" element={<Home toggleHamburger={toggleHamburger} EXTERNAL_LINKS={EXTERNAL_LINKS} />} />
              <Route path="/templates" element={<Templates toggleHamburger={toggleHamburger} />} />
              <Route path="/news" element={<News />} />
              <Route path="/editor"
                element={
                  <Editor
                    textures={textures}
                    isLoading={isLoading} />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;